import { Link } from "react-router-dom";

// Top-right "switch page" prompt on auth screens, e.g. "New to SwiftBoard? Create an account".
const AuthHeaderLink = ({ prompt, to, label }) => (
  <p className="text-[12.5px] text-text_muted">
    {prompt}{" "}
    <Link to={to} className="ml-0.5 text-primary font-semibold hover:underline underline-offset-2">
      {label}
    </Link>
  </p>
);

export default AuthHeaderLink;
